export const AUTH_STORAGE = "auth_storage";
export const IM_STORAGE = "im_storage";
